import React, { useRef, useState, useEffect } from 'react';

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Cta from "../components/CtaNomal";

import "../styles/common.css";
import "../styles/company.css";

import imgMemberCeo from "../img/members/general/ceo.JPG";
import imgMemberCto from "../img/members/general/cto.JPG";
import imgMemberCfo from "../img/members/general/cfo.JPG";
import imgMemberCdo from "../img/members/general/cdo.JPG";


const Company = () => {

  return (
    <>
      <Navbar></Navbar>
      <main className='company'>
        <section className='fvUnder'>
          <div className='fvUnder-text'>
            <h1>会社概要</h1>
            <nav aria-label="Breadcrumb" className="breadcrumb">
              <ol className='breadcrumb'>
                <li><a href="/">Home</a></li>
                <li aria-current="page">会社概要</li>
              </ol>
            </nav>
          </div>
        </section>
        <section className='about'>
          <div className="title">
            <p className='title-lead'>ABOUT</p>
            <h2>私たちについて</h2>
          </div>
          <p>LOGOT UGは、日本企業がグローバル市場に進出し、越境ECを活用して成長できるよう、包括的なサポートを提供する会社です。私たちのミッションは、企業が国際市場に円滑に参入できるよう、必要なツールと専門知識を提供することです。デジタルマーケティングからローカライズ、物流サポートまで、ワンストップでサポートを行っています。<br />2024年に設立され、ドイツのデュッセルドルフを拠点に活動する当社は、テクノロジーやクリエイティブなソリューション、そして国際市場に関する深い理解を駆使して、ビジネスの成長を支援しています。デジタルマーケティングとECの専門知識を活かし、クライアントがヨーロッパやその他の市場でビジネスを拡大し、新たな顧客層にリーチできるよう支援します。</p>
        </section>
        <section className='member'>
          <div className="title">
            <p className='title-lead'>MEMBER</p>
            <h2>メンバー</h2>
          </div>
          <div className='member-box flex'>
            <div className='member-box__item'>
              <div className='member-item__image'>
                <img src={imgMemberCeo} alt="" />
              </div>
              <div className='member-item__text'>
                <p className='member-text__post'>代表</p>
                <p className='member-text__name'>畑 心蔵</p>
                <p className='member-text__detail'>クライアントのグローバル展開を導くビジョナリーリーダー</p>
              </div>
            </div>
            <div className='member-box__item'>
              <div className='member-item__image'>
                <img src={imgMemberCto} alt="" />
              </div>
              <div className='member-item__text'>
                <p className='member-text__post'>IT</p>
                <p className='member-text__name'>渡邉 洸</p>
                <p className='member-text__detail'>最新技術を駆使して、シームレスなEC運営をサポートするITエキスパート</p>
              </div>
            </div>
            <div className='member-box__item'>
              <div className='member-item__image'>
                <img src={imgMemberCfo} alt="" />
              </div>
              <div className='member-item__text'>
                <p className='member-text__post'>ローカライズ</p>
                <p className='member-text__name'>A.K</p>
                <p className='member-text__detail'>日本語・英語ネイティブレベル、ドイツ語も話し、現地の文化や言語に最適化されたブランド戦略を策定</p>
              </div>
            </div>
            <div className='member-box__item'>
              <div className='member-item__image'>
                <img src={imgMemberCdo} alt="" />
              </div>
              <div className='member-item__text'>
                <p className='member-text__post'>デザイナー</p>
                <p className='member-text__name'>寺田 彩乃</p>
                <p className='member-text__detail'>ローカルおよびグローバル市場に響く、クリエイティブかつ効果的なデザインを提供</p>
              </div>
            </div>
          </div>
        </section>
        <section className='imformation'>
          <div className="title">
            <p className='title-lead'>COMPANY</p>
            <h2>会社情報</h2>
          </div>
          <table className='imformation-box'>
            <tbody>
              <tr>
                <th>社名</th>
                <td>LOGOT UG</td>
              </tr>
              <tr>
                <th>代表</th>
                <td>畑 心蔵</td>
              </tr>
              <tr>
                <th>連絡先</th>
                <td><a href="mailto:contact@logot.de" class="button-underLine" target="_brank">contact@logot.de</a></td>
              </tr>
              <tr>
                <th>設立</th>
                <td>29.05.2024</td>
              </tr>
              <tr>
                <th>事業内容</th>
                <td>
                  <ul className='list-disc'>
                    <li>委託プリント事業</li>
                    <li>デジタルマーケティング事業</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>会社番号</th>
                <td>
                  <ul className='list-disc'>
                    <li>Umsatzsteuer-Identifikationsnummer<br/>DE369420397</li>
                    <li>Registergericht: Amtsgericht Düsseldorf<br/>HRB 106102</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <Cta></Cta>
      </main >
      <Footer></Footer>
    </>
  );
};

export default Company